import React from "react";
import { Button } from "@material-ui/core";

export const AddButton = (props) => {
  return (
    <React.Fragment>
      <Button
        className="bg-white px-4 py-2 addBtnRed f14-700"
        style={{
          color: "#EE3A23",
          boxShadow: "0px 3px 6px #6E6E6E21",
          textTransform: "capitalize",
          borderRadius: 21,
        }}
        onClick={props.onClickPress}
        type={props.type}
        title={props.title}
      >
        <i
          className="fa fa-plus"
          style={{ fontSize: 10 }}
          aria-hidden="true"
        ></i>
        &nbsp;{props.buttonText}
      </Button>
    </React.Fragment>
  );
};
